export default __webpack_public_path__ + "static/media/MSIG.2ea97aee.png";